<div [formGroup]="learningCenterForm">
  <div class="card p-4" id="color-theme-picker-container">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <h4 style="font-weight: 700; color: #060e9f">
              กรุณาเลือกธีมสีสำหรับศูนย์เรียนรู้นี้<lifedi-require
              ></lifedi-require>
            </h4>
          </div>
          <div class="col-12">
            <nz-form-item>
              <nz-form-control [nzSpan]="8">
                <nz-select nzId="color-theme-picker-select" formControlName="THEME_ID">
                  <nz-option
                    *ngFor="let theme of learningCenterColorTheme"
                    [nzValue]="theme.THEME_ID"
                    [nzLabel]="theme.THEME_NAME"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <div *ngIf="colors$ | async as colors; else noColors">
              <div
                *ngIf="colors.length > 0; else noColors"
                class="color-palette"
              >
                <div
                  *ngFor="let color of colors"
                  class="color-box"
                  id="color_{{color}}"
                  [style.background]="color"
                ></div>
              </div>
            </div>

            <ng-template #noColors>
              <div>No colors available.</div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
